import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 新建卡池 ")
const _hoisted_6 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("已到货")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("预售中")
const _hoisted_11 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("概率")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("模拟")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("到货")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_ProbabilityPreview = _resolveComponent("ProbabilityPreview")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_SimulationModal = _resolveComponent("SimulationModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "name",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                placeholder: "卡池名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "card_series_id",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.card_series_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.card_series_id) = $event)),
                placeholder: "所属系列",
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardSeriesOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "enabled",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.enabled,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.enabled) = $event)),
                placeholder: "状态",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "启用",
                    value: "true"
                  }),
                  _createVNode(_component_el_option, {
                    label: "停用",
                    value: "false"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: { name: 'card_pools_new' },
                class: "btn btn-success ms-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          title: "图片",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.image)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  src: row.image,
                  "preview-src-list": [row.image],
                  fit: "cover",
                  style: {"width":"50px","height":"50px"}
                }, null, 8, ["src", "preview-src-list"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "name",
          title: "名称",
          width: "150"
        }),
        _createVNode(_component_vxe_column, {
          title: "所属系列",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.card_series?.name || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "价格",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(" ¥" + _toDisplayString(row.price), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "保底次数",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.energy_limit), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "卡牌数",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.items_count || 0), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "状态",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.enabled)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "info",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "sort",
          title: "排序",
          width: "80"
        }),
        _createVNode(_component_vxe_column, {
          title: "预售",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            (row.is_presale)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (row.is_arrived)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "success",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "warning",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }))
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, { title: "测试" }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", {
              style: _normalizeStyle({ color: row.is_test ? 'red' : '' })
            }, _toDisplayString(row.is_test ? '是' : ''), 5)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "创建时间",
          width: "160"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "420",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'card_pools_edit', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "info",
              size: "small",
              onClick: ($event: any) => (_ctx.onViewProbability(row))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "warning",
              size: "small",
              onClick: ($event: any) => (_ctx.onSimulate(row))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "success",
              size: "small",
              onClick: ($event: any) => (_ctx.onDuplicate(row))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (row.is_presale && !row.is_arrived)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "",
                  size: "small",
                  onClick: ($event: any) => (_ctx.onArrive(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: ($event: any) => (_ctx.onDelete(row))
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.probabilityDialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.probabilityDialogVisible) = $event)),
      title: `卡池概率 - ${_ctx.currentPool?.name || ''}`,
      width: "600px"
    }, {
      default: _withCtx(() => [
        (_ctx.currentPool)
          ? (_openBlock(), _createBlock(_component_ProbabilityPreview, {
              key: 0,
              "card-pool-id": _ctx.currentPool.id
            }, null, 8, ["card-pool-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_SimulationModal, {
      visible: _ctx.simulationDialogVisible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.simulationDialogVisible) = $event)),
      "card-pool": _ctx.simulationPool
    }, null, 8, ["visible", "card-pool"])
  ]))
}